import React from "react";
import { Outlet, useLocation } from "react-router-dom";
import Navigation from "../components/Navigation";
import Footer from "../components/Footer";
import FloatingCTA from "../components/FloatingCTA";
import CustomCursor from "../components/layout/CustomCursor";
import SmoothScroll from "../components/motion/SmoothScroll";
import ScrollToTop from "./ScrollToTop";

export default function MainLayout() {
  const { pathname } = useLocation();
  const isHome = pathname === "/";
  const mainPad = isHome ? "" : "pt-[4.25rem]";

  return (
    <div
      className={`flex min-h-screen min-w-0 max-w-[100vw] flex-col overflow-x-clip antialiased selection:bg-primary-500/25 selection:text-neutral-900 ${
        isHome ? "bg-surface-accent" : "bg-white"
      }`}
    >
      <ScrollToTop />
      <SmoothScroll />
      <CustomCursor />
      <Navigation />
      <main
        id="main-content"
        tabIndex={-1}
        className={`flex-1 min-w-0 max-w-[100vw] outline-none overflow-x-hidden ${mainPad} ${isHome ? "scroll-mt-[4.25rem]" : ""}`}
      >
        <Outlet />
      </main>
      <Footer />
      {!isHome ? <FloatingCTA /> : null}
    </div>
  );
}
